import React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const LinkOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      fill={color}
      viewBox={`0 0 ${size} ${size}`}
      {...props}
    >
      <G clipPath="url(#a)" fill={color}>
        <Path d="M7.175 17.425a4.575 4.575 0 0 1-3.258-1.342 4.575 4.575 0 0 1-1.342-3.258c0-1.233.475-2.392 1.342-3.258L5.3 8.183a.71.71 0 0 1 1 0 .71.71 0 0 1 0 1l-1.383 1.384c-.6.6-.933 1.4-.933 2.258 0 .858.333 1.658.933 2.258 1.2 1.2 3.317 1.2 4.517 0l1.233-1.233a.71.71 0 0 1 1 0 .71.71 0 0 1 0 1l-1.233 1.233a4.575 4.575 0 0 1-3.259 1.342ZM14.375 11.858a.71.71 0 0 1-.5-1.208l1.275-1.275a3.204 3.204 0 0 0 0-4.517 3.204 3.204 0 0 0-4.517 0L9.15 6.342a.71.71 0 0 1-1 0 .71.71 0 0 1 0-1l1.483-1.484c1.8-1.8 4.725-1.8 6.517 0 1.8 1.8 1.8 4.725 0 6.517l-1.275 1.275a.694.694 0 0 1-.5.208Z" />
        <Path d="M7.225 13.633a.71.71 0 0 1-.5-1.208l6.15-6.15a.71.71 0 0 1 1 0 .71.71 0 0 1 0 1l-6.15 6.15a.694.694 0 0 1-.5.208Z" />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h20v20H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default LinkOutlined
